export default class Config {

    public static readonly DEBUG = false;
    public static readonly DEBUG_HOST: string = "127.0.0.1"; //"192.168.1.5";

    public static readonly API_HOST = this.DEBUG ? `http://${this.DEBUG_HOST}:5131/` : `https://api.aikoos.com/`;
    public static readonly WEB_API_HOST = this.DEBUG ? `http://${this.DEBUG_HOST}:5131/api` : `https://api.aikoos.com/api`;
    public static readonly SignalRHost = `${this.API_HOST}sock/message`;

}